import { Stage, Module } from '../types';

export interface StageData {
  id: string;
  name: Stage;
  description: string;
  modules: Module[];
  unlocked: boolean;
  completionRate: number;
}

export const stages: StageData[] = [
  {
    id: 'newborn',
    name: Stage.NEWBORN,
    description: '0-28 天',
    modules: [Module.FEEDING, Module.SLEEP, Module.DAILY_CARE, Module.SAFETY, Module.DEVELOPMENT],
    unlocked: true,
    completionRate: 25,
  },
  {
    id: 'one-to-three',
    name: Stage.ONE_TO_THREE,
    description: '1-3 个月',
    modules: [Module.FEEDING, Module.SLEEP, Module.DAILY_CARE, Module.SAFETY, Module.DEVELOPMENT],
    unlocked: false,
    completionRate: 0,
  },
  {
    id: 'four-to-six',
    name: Stage.FOUR_TO_SIX,
    description: '4-6 个月',
    modules: [Module.FEEDING, Module.SLEEP, Module.DAILY_CARE, Module.SAFETY],
    unlocked: false,
    completionRate: 0,
  },
  {
    id: 'seven-to-twelve',
    name: Stage.SEVEN_TO_TWELVE,
    description: '7-12 个月',
    modules: [Module.FEEDING, Module.SLEEP, Module.DAILY_CARE, Module.SAFETY, Module.DEVELOPMENT],
    unlocked: false,
    completionRate: 0,
  },
];